import { createContext } from "react";
import { initialExterior } from "../init";

const ExteriorContext = createContext(initialExterior);

export default ExteriorContext;
